import {
  SET_EDITION_LIST,
  SET_PUBLICATION_TYPES,
  SET_CATEGORY,
  SET_ENTITY_LIST,
  SET_ZONES,
  SET_CLIENT_LIST,
  SET_PUBLICATION,
  SET_REPORTERS,
  SET_PRESS_RELEASE,
  SET_SOCIAL_ENTITY_LIST,
  SET_REPORTS_ENTITY_LIST,
  RESET_PUBLICATIONS,
  SET_CHANNEL_TYPE,
  SET_REPORTS_FOR_TV,
  SET_LANGUAGES,
  SET_COUNTRY,
} from "../actions/actionTypes";
import { VERTICALS } from "../constants/app-constant";
const { V_PRINT, V_ONLINE, V_BLOG, V_FORUM } = VERTICALS;

export const FILTER_NAMES = {
  RANGE: "range",
  TONALITY: "SENTIMENT",
  CHANNELS: "CHANNELS",
  PUBLICATION_TYPE: "PUBLICATION_TYPE",
  PUBLICATION: "PUBLICATION",
  EDITION: "EDITION",
  ZONE: "ZONE",
  SOURCE_TYPE: "SOURCE",
  CATEGORY: "CATEGORY",
  ENTITY: "ENTITY",
  SOCIAL_ENTITY: "SOCIAL_ENTITY",
  VERTICAL: "MEDIA_TYPE",
  CLIENT: "CLIENT",
  PRESS_RELEASE: "PRESS_RELEASE",
  KEYWORDS_SEARCH: "KEYWORDS",
  REPORTS_ENTITY: "REPORTS_ENTITY",
  CHANNELS_LIST: "CHANNEL_NAME",
  JOURNALIST: "JOURNALIST",
  LANGUAGE_LIST: "LANGUAGES",
  CHART_TYPE_LIST: "CHART_TYPE",
  COUNTRY_LIST: "COUNTRY",
};

const initialState = {
  verticalFilter: {
    name: FILTER_NAMES.VERTICAL,
    values: [
      {
        id: V_ONLINE,
        type_name: "Online",
      },
      {
        id: V_PRINT,
        type_name: "Print",
      },
    ],
    multiselect: true,
  },
  blogAndForumVerticalFilter: {
    name: FILTER_NAMES.VERTICAL,
    values: [
      {
        id: V_BLOG,
        type_name: "Blog",
      },
      {
        id: V_FORUM,
        type_name: "Forum",
      },
    ],
    multiselect: true,
  },
  tonalityFilter: {
    name: FILTER_NAMES.TONALITY,
    values: [
      { id: "Positive", tone: "Positive" },
      { id: "Negative", tone: "Negative" },
      //https://webonise.atlassian.net/browse/CB-614
      { id: "Informative", tone: "Neutral" },
      { id: "Not Rated", tone: "Not Rated" },
    ],
    multiselect: false,
  },
  publicationData: [],
  reporterData: [],
};

export const filterReducer = (
  state = initialState,
  {
    type,
    edition,
    publications,
    category,
    entity,
    zone,
    clients,
    publication_type,
    reporter,
    press_release,
    socialEntity,
    reportsEntity,
    channels,
    reports,
    languages,
    countries,
  }
) => {
  try {
    switch (type) {
      case SET_PUBLICATION_TYPES: {
        return {
          ...state,
          publicationTypeFilter: {
            name: FILTER_NAMES.PUBLICATION_TYPE,
            values: publication_type,
            multiselect: true,
          },
        };
      }

      case SET_PUBLICATION:
        return {
          ...state,
          ...{ publicationData: publications },
        };

      case RESET_PUBLICATIONS:
        return {
          ...state,
          ...{ publicationData: [] },
        };

      case SET_REPORTERS:
        return {
          ...state,
          ...{ reporterData: reporter },
        };

      case SET_PRESS_RELEASE:
        return {
          ...state,
          ...{ press_release },
        };

      case SET_EDITION_LIST:
        return {
          ...state,
          editionFilter: {
            name: FILTER_NAMES.EDITION,
            values: edition,
            multiselect: false,
          },
          editionList: edition,
        };

      case SET_CATEGORY:
        return {
          ...state,
          categoryFilter: {
            name: FILTER_NAMES.CATEGORY,
            values: category,
            multiselect: false,
          },
        };

      case SET_ENTITY_LIST:
        return {
          ...state,
          entityFilter: {
            name: FILTER_NAMES.ENTITY,
            values: entity,
            multiselect: true,
          },
        };

      case SET_REPORTS_ENTITY_LIST:
        return {
          ...state,
          reportsEntityFilter: {
            name: FILTER_NAMES.ENTITY,
            values: reportsEntity,
            multiselect: true,
          },
        };

      case SET_ZONES:
        return {
          ...state,
          zoneFilter: {
            name: FILTER_NAMES.ZONE,
            values: zone,
            multiselect: false,
          },
        };
      case SET_CHANNEL_TYPE:
        return {
          ...state,
          channelsFilter: {
            name: FILTER_NAMES.CHANNELS_LIST,
            values: channels,
            multiselect: false,
          },
        };
      case SET_LANGUAGES:
        return {
          ...state,
          languageFilter: {
            name: FILTER_NAMES.LANGUAGE_LIST,
            values: languages,
            multiselect: false,
          },
        };
      case SET_COUNTRY:
        return {
          ...state,
          countryFilter: {
            name: FILTER_NAMES.COUNTRY,
            values: countries,
            multiselect: false,
          },
        };  
      case SET_REPORTS_FOR_TV:
        return {
          ...state,
          reporterFilter: {
            name: FILTER_NAMES.JOURNALIST,
            values: reports,
            multiselect: false,
          },
        };

      case SET_SOCIAL_ENTITY_LIST:
        return {
          ...state,
          socialEntityFilter: {
            name: FILTER_NAMES.ENTITY,
            values:
              socialEntity &&
              socialEntity.map((elm) => {
                return { id: elm.id, entity_name: elm.name };
              }),
            multiselect: true,
          },
        };
      case SET_CLIENT_LIST:
        return {
          ...state,
          ...{
            filterList: [
              ...state.filterList,
              {
                name: FILTER_NAMES.CLIENT,
                values: clients,
                multiselect: false,
              },
            ],
          },
        };

      default:
        return state;
    }
  } catch (e) {
    return state;
  }
};
